<div>
  <mat-slide-toggle color="primary" [(ngModel)]="enabled" (change)="onEnabledChanged()">
    <div class="section-info">{{ title }}</div>
  </mat-slide-toggle>

  @if (enabled) {
    <form [formGroup]="form">
      <div class="box" fxLayout="row" fxLayoutGap="20px">
        <div fxFlex fxLayout="column" fxLayoutAlign="start space-between">
          @if (punchCardCampaignService.strategyType == punchCardCampaignService.strategyTypes.Points) {
            <mat-form-field fxFlex formGroupName="coinReward">
              <mat-label>Reward points</mat-label>
              <input matInput type="number" placeholder=""
                formControlName="coins" step="1" autocomplete="off" min="0">
              @if (form.get('coinReward.coins')?.errors?.['min']) {
                <mat-error>Value must be greater than or equal to 0</mat-error>
              }
            </mat-form-field>
          }
          @if (punchCardCampaignService.strategyType == punchCardCampaignService.strategyTypes.Stamps) {
            <mat-form-field fxFlex formGroupName="stampReward">
              <mat-label>Reward stamps</mat-label>
              <input matInput type="number" placeholder=""
                formControlName="stamps" step="1" autocomplete="off" min="0">
              @if (form.get('stampReward.stamps')?.errors?.['min']) {
                <mat-error>Value must be greater than or equal to 0</mat-error>
              }
            </mat-form-field>
          }
          <div fxFlex fxLayout="row" fxLayoutAlign="space-between" fxFlexFill>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxFlexFill>
              <mat-form-field fxFlex>
                <mat-label>Reward product</mat-label>
                <mat-select [compareWith]="compareProductRewardFn" (selectionChange)="onRewardSelected($event.value)" placeholder="Reward product" formControlName="productReward">
                  <mat-option [value]="null"></mat-option>
                  @for (product of rewardProductsOptions; track product.productSlug) {
                    <mat-option [value]="product" [matTooltip]="product.productSlug">{{ product.rewardTitle }}</mat-option>
                  }
                </mat-select>
                <!-- <mat-error *ngIf="!form.get('productReward').valid">Please select a reward</mat-error> -->
              </mat-form-field>
              <div fxFlex="40px">
                @if (!form.value.productReward) {
                  <lib-button fxFlex fxFlexAlign="end" (buttonClick)="onAddRewardProduct()" variant="icon" icon="add" color="primary" type="button" tooltip="Add reward product"></lib-button>
                }
                @if (form.value.productReward) {
                  <lib-button fxFlex fxFlexAlign="end" (buttonClick)="onRemoveRewardProduct()" variant="icon" icon="delete" color="primary" type="button" tooltip="Delete reward product"></lib-button>
                }
              </div>
            </div>
          </div>
        </div>
        <div fxFlex fxLayout="row" fxLayoutGap="20px">
          @if (form.value?.productReward?.rewardPhotoUrl) {
            <div class="avatar">
              <lib-photo [url]="form.value?.productReward?.rewardPhotoUrl" [width]="'153px'" [height]="'153px'" [radius]="'10px'"></lib-photo>
            </div>
          }
          <div fxFlex fxLayout="column" fxLayoutAlign="start">
            @if (form.value?.productReward?.rewardTitle) {
              <div class="info-v">
                <div class="lbl">Reward title</div>
                <div class="val" [innerHTML]="form.value?.productReward?.rewardTitle"></div>
              </div>
            }
            @if (form.value?.productReward?.rewardDescription) {
              <div class="info-v">
                <div class="lbl">Reward description</div>
                <div class="val" [innerHTML]="form.value?.productReward?.rewardDescription"></div>
              </div>
            }
          </div>
        </div>
      </div>
    </form>
  }



